import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface EventData {
  name: string;
  time: string;
  thumbnail: string;
}

@Component({
  selector: 'app-event-details-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.name ? data?.name : 'Event Data' }}</h2>
    <mat-dialog-content>
      <img [src]="data?.thumbnail" alt="Event Thumbnail" class="thumbnail-image" />
      <p>Time: {{ data.time }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Close</button>
      <button mat-button color="warn" (click)="delete()">Delete</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      mat-dialog-content {
        font-size: 16px;
        margin-bottom: 10px;
        text-align: center;
      }
      .thumbnail-image {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
        border-radius: 5px;
      }
    `
  ]
})
export class EventDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EventDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EventData
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  delete(): void {
    // Add any delete logic here
    this.dialogRef.close('deleted');
  }
}
